















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapFields } from 'vuex-map-fields';
import GlobalEvents from '@/logic/GlobalEvents';

/**
 * Test component for showing user activity heatmap
 */
@Component({
    computed: {
        ...mapFields('analytics', [
            'errors',
            'warnings'
        ]),
        ...mapFields('settings', [
            'apiUrl'
        ])
    }
})
export default class Dev extends Vue {

    private get heatmapOverlayGlobal() {
        return this.$store.getters['analytics/getHeatmapOverlayGlobal'];
    }

    private toggleHeatmapOverlayGlobal() {
        this.$store.commit('analytics/toggleHeatmapOverlayGlobal');
    }

    private get showHeatmapOverlay() {
        return this.$store.getters['analytics/getShowHeatmapOverlay'];
    }

    private toggleShowHeatmapOverlay() {
        this.$store.commit('analytics/toggleShowHeatmapOverlay');
    }

    private refresh() {
        GlobalEvents.$emit('refresh-heatmap-overlay');
    }

    private sendAnalytics() {
        this.$store.dispatch('analytics/sendHeatmap');
        this.$store.dispatch('analytics/sendLogInfo');
        this.$store.dispatch('analytics/sendDeviceInfo');
        this.$store.dispatch('analytics/sendDeviceSettings');
    }
}
